import store from "../../store/index";

export const auth = (to, from, next) => {
  const storageLoginKey = "app_login";
  if (!store.state.loginStatus) {
    if (localStorage.getItem(storageLoginKey) !== "1") {
      store.dispatch("callLogin");
      next(false);
    } else {
      next();
    }
  } else {
    next();
  }
};
